module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-2.19641b59.png";